<template>
  <div class="relative min-h-screen">
    <!-- Background -->
    <div class="fixed inset-0 z-0 vault-gradient pointer-events-none"></div>

    <!-- Navbar -->
    <nav class="relative z-10 w-full px-6 lg:px-12 py-8 flex justify-between items-center">
      <div class="flex items-center gap-3">
        <img src="/images/logo.png" style="height: 3.5rem;">
      </div>

      <a href="/login" class="text-sm font-semibold text-slate-600 hover:text-accent">
        Already joined?
      </a>
    </nav>
    <main class="relative z-10 flex-1 flex flex-col items-center justify-center px-6 pb-20">

      <div class="login-gate w-full max-w-md rounded-xl p-8 md:p-10">


            <!-- Influencer Context -->
            <div class="text-center space-y-3">
              <div class="size-14 mx-auto rounded-full bg-slate-900 text-white
                   flex items-center justify-center text-xl font-black">
                {{ influencer.name.charAt(0) }}
              </div>

              <h1 class="text-3xl font-extrabold tracking-tight">
                Join {{ influencer.name }}
              </h1>

              <p class="text-slate-500 text-sm">
                Get verified access to exclusive updates, early content,
                and direct broadcasts.
              </p>
            </div>

            <!-- Join Form -->
            <div v-if="!submitted" class="space-y-6">

              <!-- Full Name -->
              <div class="space-y-2">
                <label class="block text-[11px] font-bold uppercase tracking-widest
                     text-slate-500 ml-1">
                  Full Name
                </label>

                <div class="relative group">
                  <div class="absolute inset-y-0 left-0 pl-4 flex items-center
                       pointer-events-none text-slate-400
                       group-focus-within:text-charcoal transition-colors">
                    <i class='bx bx-user text-xl'></i>
                  </div>

                  <input v-model="form.name" type="text" placeholder="Your full name" class="w-full bg-slate-50/50 border-slate-100 rounded-lg
                       py-4 pl-12 pr-4 text-lg font-medium outline-none
                       transition-all placeholder:text-slate-300
                       input-focus-effect" />
                </div>
              </div>

              <!-- Email -->
              <div class="space-y-2">
                <label class="block text-[11px] font-bold uppercase tracking-widest
                     text-slate-500 ml-1">
                  Email Address
                </label>

                <div class="relative group">
                  <div class="absolute inset-y-0 left-0 pl-4 flex items-center
                       pointer-events-none text-slate-400
                       group-focus-within:text-charcoal transition-colors">
                    <i class='bx bx-at text-xl'></i>
                  </div>

                  <input v-model="form.email" type="email" placeholder="you@email.com" class="w-full bg-slate-50/50 border-slate-100 rounded-lg
                       py-4 pl-12 pr-4 text-lg font-medium outline-none
                       transition-all placeholder:text-slate-300
                       input-focus-effect" />
                </div>
              </div>

              <!-- Password -->
              <div class="space-y-2">
                <label class="block text-[11px] font-bold uppercase tracking-widest
                     text-slate-500 ml-1">
                  Password
                </label>

                <div class="relative group">
                  <div class="absolute inset-y-0 left-0 pl-4 flex items-center
                       pointer-events-none text-slate-400
                       group-focus-within:text-charcoal transition-colors">
                    <i class='bx bx-key text-xl'></i>
                  </div>

                  <input v-model="form.password" type="password" placeholder="your password" class="w-full bg-slate-50/50 border-slate-100 rounded-lg
                       py-4 pl-12 pr-4 text-lg font-medium outline-none
                       transition-all placeholder:text-slate-300
                       input-focus-effect" />
                </div>
              </div>

              <!-- Phone -->
              <div class="space-y-2">
                <label class="block text-[11px] font-bold uppercase tracking-widest
                     text-slate-500 ml-1">
                  Phone Number
                </label>

                <div class="relative group">
                  <div class="absolute inset-y-0 left-0 pl-4 flex items-center
                       pointer-events-none text-slate-400
                       group-focus-within:text-charcoal transition-colors">
                    <i class='bx bx-phone text-xl'></i>
                  </div>

                  <input v-model="form.phone" type="tel" placeholder="+91 XXXXXXXX" class="w-full bg-slate-50/50 border-slate-100 rounded-lg
                       py-4 pl-12 pr-4 text-lg font-medium outline-none
                       transition-all placeholder:text-slate-300
                       input-focus-effect" />


                </div>
              </div>


              <div v-if="otpSent" class="space-y-2">
                <label class="block text-[11px] font-bold uppercase tracking-widest
                     text-slate-500 ml-1">
                  OTP Here
                </label>

                <div class="relative group">
                  <div class="absolute inset-y-0 left-0 pl-4 flex items-center
                       pointer-events-none text-slate-400
                       group-focus-within:text-charcoal transition-colors">
                    <i class='bx bx-key text-xl'></i>
                  </div>

                  <input v-model="form.otp_code" type="tel" placeholder="XXXXXX" maxlength="10" class="w-full bg-slate-50/50 border-slate-100 rounded-lg
                       py-4 pl-12 pr-4 text-lg font-medium outline-none
                       transition-all placeholder:text-slate-300
                       input-focus-effect" />


                </div>
              </div>

              <!-- CTA -->
              <button @click="submit" :disabled="loading" class="w-full bg-primary hover:bg-black text-white
                  font-bold py-5 rounded-lg text-lg transition-all
                  active:scale-[0.98]
                  disabled:opacity-50 disabled:cursor-not-allowed">
                {{ loading ? "Processing..." :otpSent?"Submit OTP": "Join Now" }}
              </button>


              <!-- Trust Copy -->
              <p class="text-xs text-center text-slate-400">
                Your details are used only for verification.
                Individual fan data is never shared.
              </p>
            </div>

            <!-- Success State -->
            <div v-else class="space-y-8 text-center">
              <div class="size-14 mx-auto bg-slate-100 rounded-full
                   flex items-center justify-center text-primary">
                <i class='bx bx-check-circle text-2xl'></i>
              </div>

              <h2 class="text-2xl font-extrabold">
                Verification Started
              </h2>

              <p class="text-slate-500 text-sm">
                We’ve sent a verification link to
                <strong>{{ form.email }}</strong>.
                Complete verification to unlock access.
              </p>

              <span class="inline-block text-xs font-bold uppercase tracking-widest
                   text-slate-400">
                Almost there
              </span>
            </div>

          </div>

          <div class="mt-6 text-center text-sm text-slate-500 font-medium">
          Already having account?
          <a
            :href="'/login?inf='+influencer.id"
            class="font-bold text-accent hover:underline ml-1"
          >
            Sign In
          </a>
        </div>
    </main>
    <!-- Main -->

  </div>
</template>

<script setup>
  import { onMounted, reactive, ref } from "vue";
  import { useRoute } from "vue-router";
  import { useToast } from "vue-toastification";

  import { joinStartApi, getPublicProfileApi } from "../apis/influencerapis";
  import { sendOtpNow } from "../apis/authapis";

  const route = useRoute();
  const toast = useToast();

  const submitted = ref(false);
  const loading = ref(false);
  const otpSent = ref(false);
  const otp_txt = ref("");


  const influencer = reactive({
    id:"",
    name: "*********"
  });



  const form = reactive({
    name: "",
    email: "",
    phone: "",
    password: "",
    otp_code: ""
  });

  const loadingProfile = ref(true);

  onMounted(async () => {
    // alert(route.params.influencer_id+"");
    influencer.id = route.params.influencer_id;
    const res = await getPublicProfileApi(route.params.influencer_id);

    loadingProfile.value = false;

    if (!res.status) {
      toast.error(res.success || "Invalid creator link");
      return;
    }

    influencer.name = res.udt.user_name;
  });


  const submit = async () => {

    if (loading.value) return;

    // ✅ Basic validation
    if (!form.name.trim()) {
      toast.warning("Enter your name");
      return;
    }

    if (!form.email.trim()) {
      toast.warning("Enter your email");
      return;
    }

    if (!form.phone.trim()) {
      toast.warning("Enter your phone");
      return;
    }

    if (!form.password.trim()) {
      toast.warning("Enter your password");
      return;
    }

    loading.value = true;
    if (otpSent.value == false) {
      const res = await sendOtpNow(form.email, form.name);
      loading.value = false;
      if (res.status) {
        otp_txt.value = res.otp_text + "";
        otpSent.value = true;
      }
    }
    else {
      const res = await joinStartApi(
        route.params.influencer_id,
        form
      );

      loading.value = false;

      if (!res.status) {
        toast.error(res.success || "Join failed");
        return;
      }

      toast.success("Thanks for joining!! 🚀");
      window.location.href = "/login";
    }
    // submitted.value = true;
  };
</script>
<style scoped>
  /* ===============================
JOIN SPLIT LAYOUT
=============================== */

  .join-layout {

    width: 100%;
    max-width: 1100px;

    display: grid;
    grid-template-columns: 1fr 1fr;

    border-radius: 18px;
    overflow: hidden;

    background: white;

    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);

  }

  /* ===============================
LEFT SIDE
=============================== */
  .join-left {

    background: #ffffff;
    /* light slate background */

    color: #0f172a;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 60px 40px;

    border-right: 1px solid #e5e7eb;

  }

  .join-left-inner {
    max-width: 320px;
    text-align: center;
  }

  /* badge */

  .brand-badge {

    width: 52px;
    height: 52px;

    margin: auto;
    margin-bottom: 20px;

    border-radius: 12px;

    background: white;
    color: #0f172a;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 22px;

  }

  /* title */

  .join-title {
    font-size: 26px;
    font-weight: 800;
  }

  /* description */

  .join-desc {
    font-size: 14px;
    opacity: .85;
    margin-top: 10px;
    line-height: 1.6;
  }

  /* login button */

  .login-cta {

    display: inline-block;

    margin-top: 26px;

    padding: 12px 22px;

    background: white;
    color: #0f172a;

    font-weight: 700;
    font-size: 14px;

    border-radius: 10px;

    transition: .2s;

  }

  .login-cta:hover {
    transform: translateY(-1px);
  }

  /* ===============================
RIGHT SIDE
=============================== */

  .join-right {

    background: white;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 50px 40px;

  }

  /* ===============================
MOBILE
=============================== */

  @media (max-width:900px) {

    .join-layout {
      grid-template-columns: 1fr;
    }

    .join-left {
      padding: 40px 24px;
    }

  }

  /* ===============================
LEFT LOGIN PANEL
=============================== */

  .login-panel {
    width: 100%;
    max-width: 320px;
  }

  /* title */

  .panel-title {
    font-size: 26px;
    font-weight: 800;
  }

  /* description */

  .panel-desc {
    font-size: 14px;
    color: #94a3b8;
    margin-top: 8px;
  }

  /* label */

  .panel-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #64748b;
  }

  /* input */

  .panel-input {

    width: 100%;

    padding: 14px;

    border-radius: 10px;

    border: 1px solid #e5e7eb;

    background: #f8fafc;

    font-size: 14px;

  }

  /* login button */

  .panel-login-btn {

    width: 100%;

    background: #0f172a;
    color: white;

    padding: 14px;

    border-radius: 10px;

    font-weight: 700;

    transition: .2s;

  }

  .panel-login-btn:hover {
    background: black;
  }
</style>